import { EntityKind, EntityStage } from '@/types/schema';

interface MergeCandidate {
  kind: EntityKind;
  stage: EntityStage;
  value: string;
}

const COMPATIBLE_TRUST_KINDS = new Set([
  EntityKind.RevocableTrust,
  EntityKind.IrrevocableTrust,
]);

export function canShowEntityMerge(
  canEdit: boolean,
  canDelete: boolean,
  stage: EntityStage
): boolean {
  return canEdit && canDelete && stage !== EntityStage.PreCreated;
}

export function isEligibleMergeCandidate(
  keepEntity: Pick<MergeCandidate, 'kind' | 'value'>,
  candidate: MergeCandidate
): boolean {
  if (
    candidate.value === keepEntity.value ||
    candidate.stage === EntityStage.PreCreated
  ) {
    return false;
  }

  if (candidate.kind === keepEntity.kind) return true;

  return (
    COMPATIBLE_TRUST_KINDS.has(candidate.kind) &&
    COMPATIBLE_TRUST_KINDS.has(keepEntity.kind)
  );
}
